import React from 'react';
import { useNavigate } from 'react-router-dom';
import BankCardSelect, { BankCardItemTypes } from 'components/BankCardSelect';
import HashLink from 'components/HashLink';
import { customErrorMsgMap, NEED_COMPLETE } from '../helper';

interface BankCardProps {
    list: BankCardItemTypes[];
    currentBankInfo?: BankCardItemTypes;
    onChange?: (id: number) => void;
}

const BankCard: React.FC<BankCardProps> = ({ list, currentBankInfo, onChange }) => {
    const navigate = useNavigate();

    const handleAdd = () => {
        navigate('/profile/bankcards/add', {
            state: {
                next: '/profile/withdraw/wire',
                source: 'withdraw_manage'
            }
        });
    };

    const handleEdit = ({ id }) => {
        navigate(`/profile/bankcards/edit/${id}`, {
            state: {
                next: '/profile/withdraw/wire',
                source: 'withdraw_manage'
            }
        });
    };

    return (
        <div className="space-box">
            <p className="label">{__('Transfer Funds To')}</p>
            <BankCardSelect
                data={list}
                filterFiledValue="id"
                formItemConfig={{
                    name: 'card_id',
                    checker: value => {
                        const curr = list.find(({ id }) => String(id) === String(value));

                        if (curr && curr.id === value) {
                            const { completed } = curr;

                            if (!completed) {
                                return NEED_COMPLETE;
                            }
                        }

                        return true;
                    }
                }}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onChange={onChange}
                customErrorConfigMap={{
                    [NEED_COMPLETE]: {
                        msg: customErrorMsgMap[NEED_COMPLETE],
                        btn: currentBankInfo && (
                            <HashLink
                                onClick={() => {
                                    handleEdit(currentBankInfo);
                                }}>
                                {__('去编辑')} &gt;
                            </HashLink>
                        )
                    }
                }}
            />
        </div>
    );
};

export default BankCard;
